import { render, staticRenderFns } from "./informDialog.vue?vue&type=template&id=6ed1c640&scoped=true"
import script from "./informDialog.vue?vue&type=script&lang=js"
export * from "./informDialog.vue?vue&type=script&lang=js"
import style0 from "./informDialog.vue?vue&type=style&index=0&id=6ed1c640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed1c640",
  null
  
)

export default component.exports